var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5"},[_c('tera-file-select',{staticClass:"my-2",staticStyle:{"background":"#FFF"},attrs:{"title":'Select records to analyse...',"filters":{library: true},"placeholder":"Select records to analyse"},on:{"change":_vm.fileUpload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }